module.exports = __webpack_public_path__ + "static/media/layout.b05d74b6.png";